import { Link, useParams } from 'react-router';
import { Button } from '@newcore/ui/buttons';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { DisplaySizes } from '@newcore/ui/enums/typography-display-sizes';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';
import { Display, Text } from '@newcore/ui/typography';
import { ROUTES } from '@/common/auth-routes';
import { buildTenantPath, isValidTenantSlug } from '@/common/tenant-utils';

export function NotFoundPage() {
  const { tenant } = useParams<{ tenant: string }>();

  return (
    <div className='min-h-screen flex items-center justify-center bg-primary p-4'>
      <div className='text-center'>
        <Display
          as='h1'
          size={DisplaySizes.MD}
          weight={FontWeights.BOLD}
          className='text-tertiary mb-4'
        >
          404
        </Display>
        <Text as='p' size={TextSizes.LG} className='text-tertiary mb-4'>
          Page Not Found
        </Text>
        {isValidTenantSlug(tenant) ? (
          <Button variant={ButtonVariants.LINK_PRIMARY} asChild>
            <Link to={buildTenantPath(tenant, ROUTES.DASHBOARD)}>
              Back to your apps
            </Link>
          </Button>
        ) : (
          <Button variant={ButtonVariants.LINK_PRIMARY} asChild>
            <Link to={ROUTES.TENANT_SELECTION}>Choose organization</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
